import {Box} from '@chakra-ui/react';
import React from 'react';
import {ErrorBoundary} from 'react-error-boundary';
import {BrowserRouter as Router, Route, Switch, useHistory} from 'react-router-dom';
import NotFound from './components/error/404';
import {ErrorFallback} from './components/error/ErrorFallback';
import Auth from './components/pages/auth/Auth';
import Home from './components/home/Home';
import Student from './components/pages/student/Student';
import Teacher from "./components/pages/teacher/Teacher";
import Class from "./components/pages/class/Class";
import Admin from "./components/pages/admin/Admin";
import axios from "axios";
import StudentPrivateRoute from "./utilities/StudentPrivateRoute";
import TeacherPrivateRoute from "./utilities/TeacherPrivateRoute";
import ClassPrivateRoute from "./utilities/ClassPrivateRoute";

function App() {
  axios.defaults.baseURL = process.env.NODE_ENV === "development" ? "http://localhost:5000/api/v1" : "https://vidcom-api.herokuapp.com/api/v1";

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Box m="auto" maxWidth="1680px">
        <Router>
          <Switch>
            <Route exact path="/" component={Home}/>
            <Route path="/auth" component={Auth}/>
            <StudentPrivateRoute path="/student" component={Student}/>
            <TeacherPrivateRoute path="/tutor" component={Teacher}/>
            <Route path="/admin" component={Admin}/>
            <ClassPrivateRoute path="/class/:class" component={Class}/>
            <Route path="*" component={NotFound}/>
          </Switch>
        </Router>
      </Box>
    </ErrorBoundary>
  );
}

export default App;
